module.exports = __webpack_public_path__ + "img/1b.c62dba38.png";